<template>
    <b-dropdown
        v-model="filterTypeSelected"
        variant="secondary"
        class="no-border-right"
        no-caret
    >
        <template #button-content>
            <span class="font-weight-bold">{{ filterTypeSelected.label }}</span>
        </template>
        <b-dropdown-item
            v-for="option in filterTypeOptions"
            :key="option.value"
            @click="setFilterTypeState(option.value)"
        >
            {{ option.label }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { find } from "lodash";

export default {
    components: {},
    props: {
        filterType: {
            type: String,
            default: "all"
        }
    },
    data() {
        return {
            filterTypeSelectedValue: "",
            filterTypeSelected: { value: "all", label: "All" },
            filterTypeOptions: [
                { value: "all", label: "All" },
                { value: "name", label: "Name" },
                { value: "chip", label: "Chip" },
                { value: "tag", label: "Tag" }
            ]
        };
    },
    watch: {},
    mounted() {},
    methods: {
        setFilterTypeState(option) {
            this.filterTypeSelected = find(this.filterTypeOptions, {
                value: String(option)
            });
            this.$store.dispatch("patient/updateFilterType", option);
        }
    }
};
</script>
<style>
/* 
VET-564 : add dropdown menu on patient search dashboard 
border right none to combine with input box
*/
.no-border-right .btn {
    border-right: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    /* box-shadow: none !important; */
    height: calc(1.8rem + 2px);
    font-size: inherit;
    line-height: 1.3;
    text-align: left;
    border-color: rgba(60, 60, 60, 0.26);
}
</style>
